let ctx = null;
const on = () => localStorage.getItem("el_sfx") !== "off";

const audio = () => {
  if (!on()) return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
};

const tone = (freq, start, dur, type = "sine", gain = 0.16) => {
  const ac = audio();
  if (!ac) return;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.setValueAtTime(0, ac.currentTime + start);
  g.gain.linearRampToValueAtTime(gain, ac.currentTime + start + 0.02);
  g.gain.exponentialRampToValueAtTime(0.001, ac.currentTime + start + dur);
  osc.connect(g).connect(ac.destination);
  osc.start(ac.currentTime + start);
  osc.stop(ac.currentTime + start + dur + 0.05);
};

export const sfx = {
  correct: () => { tone(660, 0, 0.16, "triangle"); tone(880, 0.11, 0.22, "triangle"); },
  wrong: () => { tone(220, 0, 0.22, "sawtooth", 0.1); tone(165, 0.12, 0.26, "sawtooth", 0.09); },
  point: () => { tone(1040, 0, 0.09, "sine", 0.12); },
  points: () => { [880, 1100, 1320].forEach((f, i) => tone(f, i * 0.07, 0.14, "sine", 0.13)); },
  badge: () => { [523, 659, 784, 1047].forEach((f, i) => tone(f, i * 0.1, 0.32, "triangle", 0.15)); },
  click: () => { tone(520, 0, 0.06, "square", 0.06); },
  toggle: (enabled) => localStorage.setItem("el_sfx", enabled ? "on" : "off"),
  enabled: on,
};
